/**
 * Échelle d'ombre des box — une échelle, pas une valeur libre, pour que deux
 * blocs posés côte à côte ne portent pas deux ombres approchantes.
 *
 * Elle vivait dans `button/buttonStyles.js`, seule box à savoir porter une
 * ombre. Les box conteneurs (Carte info, Volet, Frise) l'ont rejointe : la
 * table est ici, à côté de `borderStyles`, et le bouton la lit toujours.
 */
export const BOX_SHADOWS = {
  none: '',
  sm: '0 1px 3px rgba(0, 0, 0, 0.12)',
  md: '0 4px 12px rgba(0, 0, 0, 0.15)',
  lg: '0 10px 24px rgba(0, 0, 0, 0.18)',
};

/** Libellé du champ, le même dans les deux inspecteurs. */
export const SHADOW_LABEL = 'Ombre';

/** Options du champ, dans l'ordre de l'échelle. */
export const SHADOW_OPTIONS = [
  { value: 'none', label: 'Aucune' },
  { value: 'sm', label: 'Légère' },
  { value: 'md', label: 'Moyenne' },
  { value: 'lg', label: 'Forte' },
];

/** Le CSS d'une clé d'échelle, `''` pour « aucune » comme pour l'inconnu. */
export const boxShadowCss = (key) => BOX_SHADOWS[key] || '';
